<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/PMReport/PMSpare'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input readonly type="text" class="form-control" placeholder="(ดด/ปปปป)" id="reStartDate" name="reStartDate" ref="reStartDate" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input readonly type="text" class="form-control" placeholder="(ดด/ปปปป)" id="reEndDate" name="reEndDate" ref="reEndDate" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartment'"
                    :name="'reDepartment'"
                    :select2-options="reDepartmentOptions"
                    v-model="reDepartment"
                    @selectChange="onDepartmentChange"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCode'"
                    :name="'reAgentCode'"
                    :select2-options="reAgentCodeOptions"
                    v-model="reAgentCode"
                    @selectChange="onReAgentCodesChange()"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ชื่อช่าง:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reUserId'"
                    :name="'reUserId'"
                    :select2-options="reUserIdOptions"
                    v-model="reUserId"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="exportExcel">
                  <span> <i class="fas fa-file-export"></i><span>Export Excel</span> </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap" id="PMSpareTable" style="width:100%">
                <thead>
                  <tr>
                    <th class="all text-right" colspan="8">ข้อมูล ณ วันที่ {{ reAaDateReq }}</th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">เขตขาย</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <!-- <th class="all text-center">วันที่</th> -->
                    <th class="all text-center">เดือน</th>
                    <th class="all text-center">ปี</th>
                    <th class="all text-center">รายการอะไหล่</th>
                    <th class="all text-center">
                      จำนวนอะไหล่ที่ใช้ในการซ่อมบำรุง
                    </th>
                    <th class="all text-center">ชื่อช่าง</th>
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reDepartment: null,
      reAgentCode: null,
      reUserId: null,
      reIsInitial: true,
      reAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
              SalesAreaId: self.reDepartment,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      reDepartmentOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reUserIdOptions: {
        placeholder: "กรุณาเลือกชื่อช่าง",
        allowClear: false,
        ajax: {
          type: "post",
          dataType: "json",
          contentType: "application/json",
          url: "/Api/Users/Select2UserGroupAgent2",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              agentCode: self.reAgentCode
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reAgentCode = null;
      self.reDepartment = null;
      self.reUserId = null;

      $("#reStartDate")
        .val("")
        .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      $("#reAgentCode")
        .val("")
        .trigger("change");

      $("#reDepartment")
        .val("")
        .trigger("change");

      $("#reUserId")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#PMSpareTable").DataTable();
      table.draw();
    },
    exportExcel: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportPMSpare",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAgentCode,
          SalesArea: self.reDepartment,
          UserId: self.reUserId,
          IsInitial: self.reIsInitial,
          MonthStart: self.reStartDate != null ? self.reStartDate.format("MM/YYYY") : self.reStartDate,
          MonthEnd: self.reEndDate != null ? self.reEndDate.format("MM/YYYY") : self.reEndDate,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    onDepartmentChange() {
      this.reAgentCode = null;

      $("#reAgentCode")
        .val("")
        .trigger("change");
    },
    onReAgentCodesChange() {
      this.reUserId = null;

      $("#reUserId")
        .val("")
        .trigger("change");
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    /*$(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });*/

    $(self.$refs.reStartDate).datepicker({
      format: "mm/yyyy",
      viewMode: "months",
      minViewMode: "months",
      autoclose: true,
      clearBtn: true,
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      templates: arrows,
    });
    $(self.$refs.reStartDate)
      .datepicker("update", !!self.reStartDate ? self.reStartDate.format("MM/YYYY") : null)
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    /*$(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });*/

    $(self.$refs.reEndDate).datepicker({
      format: "mm/yyyy",
      viewMode: "months",
      minViewMode: "months",
      autoclose: true,
      clearBtn: true,
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      templates: arrows,
    });
    $(self.$refs.reEndDate)
      .datepicker("update", !!self.reEndDate ? self.reEndDate.format("MM/YYYY") : null)
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#PMSpareTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/PMSpare",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function(d) {
            let jsonSearch = {
              AgentCode: self.reAgentCode,
              SalesArea: self.reDepartment,
              UserId: self.reUserId,
              IsInitial: self.reIsInitial,
              MonthStart: self.reStartDate != null ? self.reStartDate.format("MM/YYYY") : null,
              MonthEnd: self.reEndDate != null ? self.reEndDate.format("MM/YYYY") : null,
              /*StartDate:
                self.reStartDate != null
                  ? self.reStartDate.format("DD/MM/YYYY")
                  : self.reStartDate,
              EndDate:
                self.reEndDate != null
                  ? self.reEndDate.format("DD/MM/YYYY")
                  : self.reEndDate,*/
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[3, "desc"]],
        columns: [
          {
            data: "department",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "department", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "pmStartDateMonth", className: "text-center" },
          { data: "pmStartDateYear", className: "text-center" },
          // {
          //   data: "pmStartDate",
          //   className: "text-center",
          //   render: function(data, type, full, meta) {
          //     return full.pmStartDateFormat;
          //   },
          // },
          { data: "materialName", className: "text-left" },
          { data: "sumAmount", className: "text-center" },
          { data: "fullName", className: "text-center" },
        ],
        drawCallback: function(settings) {
          self.reIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/PMSpare.vue